const select = {
	borderWidth: '0px 10px',
	borderColor: '#fff',
	backgroundColor: '#fff',
	height: 42,
	fontSize: 14,
};

export { select };
